// Centralized test IDs
export const T = {
  nav: {
    logo: "site-nav-logo",
    home: "site-nav-home",
    services: "site-nav-services",
    book: "site-nav-book",
    quote: "site-nav-quote",
    about: "site-nav-about",
    franchising: "site-nav-franchising",
    commercial: "site-nav-commercial",
    contact: "site-nav-contact",
    login: "site-nav-login",
    faq: "site-nav-faq",
    mobileToggle: "site-nav-mobile-toggle",
  },
  faq: {
    list: "faq-list",
    item: (id) => `faq-item-${id}`,
    toggle: (id) => `faq-toggle-${id}`,
    answer: (id) => `faq-answer-${id}`,
  },
  home: {
    heroBookBtn: "home-hero-book-btn",
    heroQuoteBtn: "home-hero-quote-btn",
    servicesGrid: "home-services-grid",
  },
  booking: {
    stepIndicator: "booking-step-indicator",
    serviceCard: (slug) => `booking-service-${slug}`,
    next: "booking-next-btn",
    back: "booking-back-btn",
    firstName: "booking-first-name-input",
    lastName: "booking-last-name-input",
    email: "booking-email-input",
    phone: "booking-phone-input",
    address: "booking-address-input",
    zip: "booking-zip-input",
    dateInput: "booking-date-input",
    slot: (iso) => `booking-slot-${iso}`,
    consentSms: "booking-consent-sms",
    consentEmail: "booking-consent-email",
    honeypot: "booking-honeypot",
    submit: "booking-submit-btn",
    successCard: "booking-success-card",
  },
  quote: {
    submit: "quote-submit-btn",
    firstName: "quote-first-name-input",
    lastName: "quote-last-name-input",
    email: "quote-email-input",
    phone: "quote-phone-input",
    address: "quote-address-input",
    notes: "quote-notes-input",
    successCard: "quote-success-card",
  },
  contact: {
    firstName: "contact-first-name-input",
    lastName: "contact-last-name-input",
    email: "contact-email-input",
    phone: "contact-phone-input",
    message: "contact-message-input",
    submit: "contact-submit-btn",
    successCard: "contact-success-card",
  },
  franchise: {
    firstName: "franchise-first-name-input",
    lastName: "franchise-last-name-input",
    email: "franchise-email-input",
    phone: "franchise-phone-input",
    submit: "franchise-submit-btn",
    successCard: "franchise-success-card",
  },
  admin: {
    sidebar: "admin-sidebar",
    logout: "admin-logout-btn",
    linkDashboard: "admin-link-dashboard",
    linkCalendar: "admin-link-calendar",
    linkContacts: "admin-link-contacts",
    linkPipeline: "admin-link-pipeline",
    linkJobs: "admin-link-jobs",
    linkInbox: "admin-link-inbox",
    linkAutomations: "admin-link-automations",
    linkSettings: "admin-link-settings",
  },
  login: {
    email: "login-email-input",
    password: "login-password-input",
    submit: "login-submit-btn",
    error: "login-error",
  },
  dashboard: {
    kpiJobsToday: "kpi-jobs-today",
    kpiNewLeads: "kpi-new-leads",
    kpiRevenue: "kpi-revenue-mtd",
    kpiPendingReviews: "kpi-pending-reviews",
    upcomingList: "dashboard-upcoming",
    activityList: "dashboard-activity",
  },
  contacts: {
    row: (id) => `contact-row-${id}`,
    search: "contacts-search",
    addBtn: "contacts-add-btn",
    firstName: "contacts-first-name-input",
    lastName: "contacts-last-name-input",
    phone: "contacts-phone-input",
    email: "contacts-email-input",
    save: "contacts-save-btn",
  },
  payments: {
    page: "admin-payments-page",
    nav: "admin-nav-payments",
    row: (id) => `payment-row-${id}`,
    refund: (id) => `payment-refund-${id}`,
    copy: (id) => `payment-copy-${id}`,
    open: (id) => `payment-open-${id}`,
    filter: (name) => `payments-filter-${name}`,
  },
  pipeline: {
    column: (stage) => `pipeline-col-${stage}`,
    card: (id) => `pipeline-card-${id}`,
    moveNext: (id) => `pipeline-move-next-${id}`,
    movePrev: (id) => `pipeline-move-prev-${id}`,
  },
  jobs: {
    row: (id) => `job-row-${id}`,
    addBtn: "jobs-add-btn",
    complete: (id) => `job-complete-${id}`,
    cancel: (id) => `job-cancel-${id}`,
  },
  inbox: {
    row: (id) => `inbox-msg-${id}`,
    contactSelect: "inbox-contact-select",
    channel: "inbox-channel-select",
    body: "inbox-body",
    send: "inbox-send-btn",
  },
  automations: {
    row: (key) => `automation-row-${key}`,
    toggle: (key) => `automation-toggle-${key}`,
    edit: (key) => `automation-edit-${key}`,
    logs: "automation-logs",
  },
  settings: {
    twilioBadge: "settings-twilio-badge",
    sendgridBadge: "settings-sendgrid-badge",
    googleBadge: "settings-google-badge",
    connectGoogle: "settings-connect-google",
    clearDemo: "settings-clear-demo",
    reseedDemo: "settings-reseed-demo",
  },
};
